import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { Stats } from "@/components/site/Stats";
import { Services } from "@/components/site/Services";
import { CareersNewsletter } from "@/components/site/CareersNewsletter";
import { StoriesTeaser } from "@/components/site/StoriesTeaser";
import { Partners } from "@/components/site/Partners";
import { FinalCta } from "@/components/site/FinalCta";
import { Footer } from "@/components/site/Footer";

export default function Home() {
  return (
    <main data-testid="home-page" className="bg-white text-ink">
      <Navbar />
      <Hero />
      <Stats />
      <Services />
      <StoriesTeaser />
      <CareersNewsletter />
      <Partners />
      <FinalCta />
      <Footer />
    </main>
  );
}
